module.exports = __webpack_public_path__ + "static/img/3.fca7606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/3.png
// module id = K6h5
// module chunks = 0